<template>
  <b-col
    v-if="areaIdList.length > 0"
    cols="6"
  >
    <div
      style="height: 35px; margin-bottom: 30px"
    >
      <h4
        class="text-center"
        style="color: #8d949d; font-weight: 300"
      >
        {{ $t('quick_pay_verification_header') }}
      </h4>
    </div>

    <b-modal
      id="confirmQuickShifts"
      :title="$t('quick_pay_verification_header')"
      @hidden="resetModal"
    >
      <div v-if="user.role !== 'customer'">
        <v-select
          v-if="formVerifiedShifts.data.length >= 1"
          v-model="formVerifiedShifts.emails"
          multiple
          taggable
          :no-drop="true"
          style="text-transform: lowercase"
          :placeholder="`${$t('action_center.email_placeholder') }`"
        />
        <small
          v-if="!formVerifiedShifts.emails.length"
          class="text-danger"
        >
          {{ $t('action_center.client_email_warning') }}
        </small>
      </div>

      <div
        v-if="formVerifiedShifts.data.length >= 1"
        class="mt-2"
      >
        <b-card
          v-for="shift in formVerifiedShifts.data"
          :key="shift.id"
          class="border-b-2 py-2"
        >
          <app-collapse>
            <app-collapse-item
              :title="`${getUserFullName(shift.user)} | ${ getDatetimeLocale(shift.start) } - ${getTimeLocale(shift.end) }`"
              class="capitalized d-flex justify-space-between"
            >
              <b-card-text>{{ $t('action_center.assigned_label') }} : {{ getUserFullName(shift.user) }}</b-card-text>
              <b-card-text>{{ $t('action_center.role') }} : {{ shift.user.role.label }}</b-card-text>
              <b-card-text>{{ $t('action_center.permission') }} : {{ shift.user.love ? $t('action_center.permissible') : $t('action_center.unauthorized') }}</b-card-text>
              <b-card-text>{{ $t('action_center.start_str') }} : {{ getDatetimeLocale(shift.start) }}</b-card-text>
              <b-card-text>{{ $t('action_center.end_str') }} : {{ getDatetimeLocale(shift.end) }}</b-card-text>
            </app-collapse-item>
          </app-collapse>

        </b-card>
      </div>
      <template #modal-footer="{}">
        <b-button
          variant="outline-primary"
          @click="onConfirmShift"
        >
          {{ $t('action_center.confirm') }}
        </b-button>
        <b-button
          v-if="user.role !== 'customer'"
          variant="primary"
          :disabled="!formVerifiedShifts.emails.length || sendingVerification"
          @click="onSendVerifies"
        >
          {{ $t('action_center.send_confirmation') }}
        </b-button>
      </template>
    </b-modal>

    <b-card
      v-for="areaId in areaIdList"
      :key="areaId"
      class="text-capitalize w-full"
    >
      <template #header>
        <div class="header-container">
          <span class="font-weight-bold header-title">
            {{ getShiftByAreaId(areaId).pop().area.name }}
          </span>
          <b-button
            type="button"
            variant="outline-primary"
            class="header-button"
            @click="verifyShiftsByAreaId(areaId)"
          >
            {{ $t('action_center.verify_all_shifts') }}
          </b-button>
        </div>
      </template>

      <b-card-text>
        <app-collapse v-if="getShiftByAreaId(areaId).length > 0">
          <app-collapse-item
            :title="`Varattuja vuoroja: ${getShiftByAreaId(areaId).length}`"
            :is-visible="areaIdList.length === 1"
          >
            <app-timeline>
              <app-timeline-item
                v-for="(shift, index) in getShiftByAreaId(areaId)"
                :key="`${shift.contractId}${index}`"
                variant="warning"
                class="ml-2 d-flex justify-content-between"
              >
                <b-card class="quick-shift-item">
                  <template #header>
                    <div>
                      <!-- <span class="font-weight-bold header-title">
                        {{ shift.area.name }}
                      </span> -->
                      <div>
                        <b-badge
                          :variant="shift.finalConfirmation.sent === false && shift.finalConfirmation.confirmed === false ? 'warning' : 'info'"
                        >
                          {{
                            shift.finalConfirmation.sent === false &&
                              shift.finalConfirmation.confirmed === false ?
                                $t('action_center.confirm_shift_completed') :
                                $t('action_center.waiting_confirm')
                          }}
                        </b-badge>
                      </div>
                    </div>
                    <b-button
                      type="button"
                      variant="outline-primary"
                      class="btn-confirm"
                      @click="verifyQuickShifts(shift.id)"
                    >
                      {{ $t('action_center.confirm_quick_shift') }}
                    </b-button>
                  </template>
                  <app-collapse>
                    <app-collapse-item
                      :title="`${$t('action_center.assigned_label')}: ${getUserFullName(shift.user)}`"
                      style="margin-left: -15px"
                    >
                      <b-card-text class="ml-1">
                        {{ $t('action_center.role') }}:
                        <span style="text-transform: capitalize; font-weight: 600">
                          {{ shift.user.role.label }}
                        </span>
                      </b-card-text>

                      <b-card-text class="ml-1">
                        {{ $t('action_center.permission') }}:
                        <span style="text-transform: capitalize; font-weight: 600">
                          {{ shift.user.love ? $t('action_center.permissible') : $t('action_center.unauthorized') }}
                        </span>
                      </b-card-text>

                      <b-card-text class="ml-1">
                        {{ $t('action_center.phone_number') }}:
                        <span style="text-transform: lowercase; font-weight: 600">
                          {{ shift.user.mobile }}
                        </span>
                      </b-card-text>
                      <b-card-text class="ml-1">
                        {{ $t('action_center.email') }}:
                        <span style="text-transform: lowercase; font-weight: 600">
                          {{ shift.user.email }}
                        </span>
                      </b-card-text>
                    </app-collapse-item>
                  </app-collapse>

                  <b-card-text>
                    {{ $t('action_center.start_str') }}: {{ getDatetimeLocale(shift.start) }}
                  </b-card-text>

                  <b-card-text>
                    {{ $t('action_center.end_str') }}: {{ getDatetimeLocale(shift.end) }}
                  </b-card-text>
                </b-card>
              </app-timeline-item>
            </app-timeline>
          </app-collapse-item>
        </app-collapse>
      </b-card-text>
    </b-card>
  </b-col>
</template>

<script>
import AppCollapse from '@hw-ui/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@hw-ui/components/app-collapse/AppCollapseItem.vue'
import AppTimeline from '@hw-ui/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@hw-ui/components/app-timeline/AppTimelineItem.vue'
import {
  BCard, BCardText, BButton, BModal, BCol, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import { createPayrolls, savePayrolls } from '@/shared/services/payrollService'
import { capitalize } from '@hw-core/utils'

function getNumberOfWeek(date) {
  const tdt = new Date(date.valueOf())
  const dayn = (date.getDay() + 6) % 7
  tdt.setDate(tdt.getDate() - dayn + 3)
  const firstThursday = tdt.valueOf()
  tdt.setMonth(0, 1)
  if (tdt.getDay() !== 4) {
    // eslint-disable-next-line no-mixed-operators
    tdt.setMonth(0, 1 + ((4 - tdt.getDay()) + 7) % 7)
  }
  return 1 + Math.ceil((firstThursday - tdt) / 604800000)
}
function addShiftToTable(shift) {
  /* eslint-disable quotes */
  /* eslint-disable prefer-template */
  const { user } = shift
  const { fullName } = user
  const start = shift.start.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
  const end = shift.end.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
  const date = shift.start.toLocaleString('fi', { month: 'numeric', day: 'numeric' })
  const message = `
                  <tr>
                  <td style="text-transform:capitalize">` + fullName + `</td>
                  <td>` + date + `</td>
                  <td>` + start + `</td>
                  <td>` + end + `</td>
                  <td> V | X </td>
                  </tr>
              `

  return message
}
export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BModal,
    BCol,
    BBadge,
    AppCollapse,
    AppCollapseItem,
    AppTimeline,
    AppTimelineItem,
    vSelect,
  },

  props: {
    processer: {
      type: Object,
      default: () => {},
    },
    user: {
      type: Object,
      default: () => {},
    },
    createConfirmationTicket: {
      type: Function,
      required: true,
    },
    createClientRequest: {
      type: Function,
      required: true,
    },
    updateShift: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      shiftsNeedConfirm: [],
      areaIdList: [],
      formVerifiedShifts: {
        areaId: null,
        shiftId: null,
        data: [],
        emails: [],
      },
      sendingVerification: false,
    }
  },
  computed: {
    getUserFullName() {
      return user => user?.fullName || ''
    }
  },
  created() {
    this.$emit('fetchShiftPikapalkka', change => {
      const { type, data } = change
      if (type === 'added') {
        if (this.areaIdList && this.areaIdList.indexOf(data.areaId) === -1) {
          this.areaIdList.push(data.areaId)
        }
        this.shiftsNeedConfirm.unshift({
          ...data,
          start: data.start.toDate(),
          end: data.end.toDate(),
        })
      }
      if (type === 'removed') {
        if (this.areaIdList && this.areaIdList.some(item => item === data.areaId)) {
          if (this.getShiftByAreaId(data.areaId).length === 1) {
            this.areaIdList = this.areaIdList.filter(item => item !== data.areaId)
          }
        }
        this.shiftsNeedConfirm = this.shiftsNeedConfirm.filter(shift => shift.id !== data.id)
      }
      if (type === 'modified') {
        this.shiftsNeedConfirm = this.shiftsNeedConfirm.map(shift => {
          if (shift.id === data.id) {
            return {
              ...shift,
              ...data,
              start: data.start.toDate(),
              end: data.end.toDate(),
            }
          }
          return shift
        })
      }
    })
  },
  methods: {
    getTimeLocale(dt) {
      return dt.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
    },

    getDatetimeLocale(dt) {
      return dt.toLocaleString('fi', {
        month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric',
      })
    },

    verifyQuickShifts(shiftId) {
      this.formVerifiedShifts.shiftId = shiftId
      this.formVerifiedShifts.data = this.shiftsNeedConfirm.filter(item => item.id === shiftId)
      const { area } = this.formVerifiedShifts.data[0]
      this.formVerifiedShifts.emails = area.confirmation_emails && area.confirmation_emails.length > 0 ? area.confirmation_emails : area.emails
      this.formVerifiedShifts.emails = this.formVerifiedShifts.emails ? this.formVerifiedShifts.emails : []
      this.$bvModal.show('confirmQuickShifts')
    },

    verifyShiftsByAreaId(areaId) {
      this.formVerifiedShifts.areaId = areaId
      this.formVerifiedShifts.data = this.getShiftByAreaId(areaId)
      const { area } = this.formVerifiedShifts.data[0]
      this.formVerifiedShifts.emails = area.confirmation_emails && area.confirmation_emails.length > 0 ? area.confirmation_emails : area.emails
      this.formVerifiedShifts.emails = this.formVerifiedShifts.emails ? this.formVerifiedShifts.emails : []
      this.$bvModal.show('confirmQuickShifts')
    },

    getShiftByAreaId(areaId) {
      return this.shiftsNeedConfirm
        .filter(item => item.areaId === areaId)
        .sort((a, b) => {
          const c = new Date(a.startDate)
          const d = new Date(b.startDate)
          return c - d
        })
    },

    async onConfirmShift() {
      try {
        const update = {
          processer: `${this.processer.firstName} ${this.processer.lastName}`,
          date: new Date(),
          state: 'confirmed',
          content: ['finalConfirmation: confirmed'],
        }
        const shifts = this.formVerifiedShifts.data
        await Promise.all(shifts.map(async shift => {
          const finalConfirmation = {
            ...shift.finalConfirmation,
            confirmed: true,
          }
          const status = 'confirmed'
          const { updates } = shift
          updates.push(update)
          await this.updateShift({ id: shift.id, updates: { finalConfirmation, status, updates } })
        }))

        this.sendingVerification = true
        this.$emit('sendConfimationToPayroll', shifts)
        this.$emit('sendPikapalkkaSMS', shifts)
        this.sendingVerification = false
        this.$bvModal.hide('confirmQuickShifts')
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('success'),
            text: this.$t('action_center.toast_message.confirm_shifts_success'),
            icon: 'CheckIcon',
            variant: 'success',
          },
        })

        // Create payrolls
        const payrollList = await createPayrolls(shifts, true, {
          from: shifts.sort((a, b) => a.start - b.start)[0].start,
          to: shifts.sort((a, b) => b.end - a.end)[0].end,
          addPeriodOvertime: false,
        })
          await savePayrolls(payrollList)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },

    createNewInspectionTicketMessage(shifts) {
      let message = ''
      const messageStart = `<p>Hei,</p>
                  <p>Pyydämme teiltä vahvistusta alla mainittuihin vuoroihin. Tarvitsemme vuorojen vahvistuksen laskutusta sekä palkanmaksua varten.</p>
                  <p><b>Voitte kopioida taulukon ja merkitä V (Suoritettu) tai X (Ei suoritettu). Jos vuoro on suoritettu, mutta alkamis- tai loppumisaika on eri, voitte kirjata myös sen taulukkoon.</b></p>`
      message += messageStart
      const weeks = Array.from(new Set(this.formVerifiedShifts.data.map(shift => getNumberOfWeek(shift.start))))
      const shiftsInWeeks = weeks.map(week => shifts.filter(shift => getNumberOfWeek(shift.start) === week))
      message += shiftsInWeeks.map(s => {
        if (!s || s.length < 1) { return '' }
        let tables = ''
        const week = getNumberOfWeek(s[0].start)
        const weekTableStart = `
                  <table style="margin-bottom: 10px">
                  <tr>
                    <th>${this.$t('week')}: ${week}</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                  <th>${this.$t('shift_worker')}</th>
                  <th>Pvm</th>
                  <th>${this.$t('started')}</th>
                  <th>${this.$t('ended')}</th>
                  <th>${this.$t('completed')} (V) | ${this.$t('not_completed')} (X)</th>
                  </tr>
                  `
        tables += weekTableStart
        s.forEach(shift => {
          tables += addShiftToTable(shift)
        })
        const weekTableEnd = `
                  </table>`
        tables += weekTableEnd
        return tables
      }).join('')
      const messageEnd = `
                  <p>Voitte antaa vastauksenne vastaamalla tähän viestiin.
                  <p>Ystävällisin terveisin,</p>
                  <p>Hoiwa ‑tiimi</p>`

      message += messageEnd
      return message
    },

    async onSendVerifies() {
      this.sendingVerification = true
      const to = this.formVerifiedShifts.emails
      const areaName = this.formVerifiedShifts.data[0].area.name
      const subject = capitalize(areaName) + ' - Pikapalkka vuorojen tarkistus'
      const shifts = this.formVerifiedShifts.data
      if (shifts.length < 1) {
        return
      }
      try {
      // Create ticket
        const message = this.createNewInspectionTicketMessage(shifts)
        const result = await this.createConfirmationTicket({
          requester: this.processer.email,
          groupId: '4415022971153',
          message,
          collaborators: to,
          subject,
        })
        // Create client request
        const ticketId = result.id
        const response = await this.createClientRequest({
          ticketId: result.id,
          processer: `${this.processer.firstName} ${this.processer.lastName}`,
          type: 'quick_shifts_confirmation',
          status: 'open',
          name: capitalize(areaName) + ' - Pikapalkka vuorojen tarkistus',
          updates: 0,
        })

        // Add client request and ticket id to shifts
        await Promise.all(shifts.map(async shift => {
          const updates = shift.updates ? shift.updates : []
          const finalConfirmation = {
            ...shift.finalConfirmation,
            sent: true,
            ticketId,
            sentTime: new Date(),
            sender: {
              firstName: this.processer.firstName,
              lastName: this.processer.lastName,
            },
          }
          const update = {
            processer: `${this.processer.firstName} ${this.processer.lastName}`,
            date: new Date(),
            state: 'shift check',
            content: ['shift check: created', `Ticket: #${ticketId}`],
          }
          updates.push(update)
          const confirmationRequest = response
          await this.updateShift({ id: shift.id, updates: { finalConfirmation, updates, confirmationRequest } })
        }))
        // Hide modal
        this.sendingVerification = false
        this.$bvModal.hide('confirmQuickShifts')
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('success'),
            text: this.$t('action_center.toast_message.confirm_quick_shifts_success'),
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    resetModal() {
      this.formVerifiedShifts = {
        areaId: null,
        shiftId: null,
        data: [],
        emails: [],
      }
    },
  },
}
</script>

<style scoped>
  .header-container {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
  }
  .header-title {
    font-size: 16px;
  }
  .btn-confirm {
    max-height: 38px;
  }
  .capitalized {
    text-transform: capitalize;
  }
  .quick-shift-item {
    width: 100%;
  }
  .quick-shift-item .card-header {
    padding: 0;
    justify-content: space-between
  }
</style>
